import React, { Component } from 'react';
import styles from './Input.module.css';

import MaterialInput from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';

class Input extends Component {

  checkInputStyle(){
    let className = '';
    if(this.props.inputClassName){
      className += this.props.inputClassName + ' ';
    }
    if(this.props.light){
      className += styles.formFieldLight;
    }else{
      className += styles.formField;
    }
    return className;
  }

  checkFormStyle(){
    let className = styles.formField;
    if(this.props.className){
      className += this.props.className;
    }
    return className;
  }

  render() {
    let { inputClassName, noLine, errorText, helperText, endAdornment, startAdornment, label, InputLabelProps, ...rest } = this.props;

    let lineStyle = styles.inputUnderline;

    if(noLine){
      lineStyle = styles.noUnderline;
    }

    return (
      <FormControl className={this.checkFormStyle()}>
        <MaterialInput
                {...rest}
                classes={{underline: lineStyle, inputMultiline: 'multiline'}}
                className={this.checkInputStyle()}
                endAdornment={<InputAdornment position="end">
                    <label className={styles.adornment}>{endAdornment || ''}</label>
                </InputAdornment>}
                startAdornment={startAdornment && <InputAdornment position="start">
                    <label>{startAdornment}</label>
                </InputAdornment>}
        />
        <FormHelperText className={errorText ? styles.formError : styles.inputHelperText}>
          {errorText ? errorText : helperText || null}
        </FormHelperText>
      </FormControl>
    );
  }

}

export default Input;